import { gql } from '@apollo/client';

export const qualityReturnReceiptQuery = gql`
  query ($returnReceiptId: ID!) {
    qualityReturnReceipt(returnReceiptId: $returnReceiptId) {
      personId
      supplierName
      returnReceiptId
      productId
      productName
      productDivisionName
      productGroupId
      productGroupName
      receiptDate
      scheduledQuantity
      inspectedQuantity
      returnedQuantity
      stokedQuantity
      returnReceiptReasons {
        reasonCode
        reasonDescription
      }
      noteDescription
    }
  }
`;
